var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("\n    "+_vm._s(_vm.I18n.t("table.number"))+"\n  ")]),_vm._v(" "),_vm._l((_vm.columnNames),function(columnName,index){return _c('th',{key:index},[_vm._v("\n    "+_vm._s(_vm.I18n.t(("artworks." + columnName)))+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-215c2d3b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/employees_orders_panel/components/table/main_table_head.vue
// module id = 797
// module chunks = 0 1 2 3 4 5 6 7 8 10 20 367